import { AutocompleteRawContext } from '@jupiterone/query-language-autocomplete';
import { J1ApolloClient } from '@jupiterone/jupiter-web-toolkit';
import addMinutes from 'date-fns/add_minutes';
import { localStorageData } from '../backingStore';
import { isAutocompleteData, LoadAutocompleteData } from './types';

export const DEFAULT_AUTOCOMPLETE_DATA: AutocompleteRawContext = {
  entities: [],
  properties: {},
  relationships: {},
  substitutions: [],
};

const withDefault = ({ backing, ...inputData }: LoadAutocompleteData) => {
  const context = {
    expires: addMinutes(new Date(), 24 * 60),
    backing:
      backing ||
      localStorageData(
        'autocomplete-context',
        DEFAULT_AUTOCOMPLETE_DATA,
        isAutocompleteData
      ),
    ...inputData,
  };

  const client = inputData.client || J1ApolloClient.sharedOptional();
  if (!client) {
    throw new Error('Apollo client is required.');
  }

  return { ...context, client };
};

export default withDefault;
